<component class="app-icon" :is="iconComponent" :width="width" :height="width" :style="{ color }"></component>